import { render, staticRenderFns } from "./Tvcctv.vue?vue&type=template&id=a324fa14&scoped=true&"
import script from "./Tvcctv.vue?vue&type=script&lang=js&"
export * from "./Tvcctv.vue?vue&type=script&lang=js&"
import style0 from "./Tvcctv.vue?vue&type=style&index=0&id=a324fa14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a324fa14",
  null
  
)

export default component.exports